import { useState, useEffect } from 'react';

export const useEmployeeFilters = () => {
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [filterActive, setFilterActive] = useState('All');
  const [filterRole, setFilterRole] = useState('All');
  const [page, setPage] = useState(1);

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

  const resetFilters = () => {
    setSearch('');
    setDebouncedSearch('');
    setFilterActive('All');
    setFilterRole('All');
    setPage(1);
  };

  const filters = {
    search: debouncedSearch,
    filterActive,
    filterRole,
    page,
  };

  return {
    search,
    setSearch,
    debouncedSearch,
    filterActive,
    setFilterActive,
    filterRole,
    setFilterRole,
    page,
    setPage,
    resetFilters,
    filters,
  };
};
